import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { PublicUser } from "@/app/types/auth/PublicUser";
import { CREDIT_WALLET_DRAW_ORDER, CreditBucket } from "@/app/types/billing/CreditWallet";

export type UserState = {
  user: PublicUser | null;
  setUser: (user: PublicUser) => void;
  decrementCredits: (amount: number, bucket: CreditBucket) => void;
};

export const UserStore = create<UserState>()(
  devtools((set, getState) => ({
    user: null,

    setUser: (user) => set({ user }),

    decrementCredits: (amount: number, bucket: CreditBucket) => {
      const user = getState().user;
      if (!user) return;

      const next = { ...user };
      let remaining = amount;

      for (const column of CREDIT_WALLET_DRAW_ORDER[bucket]) {
        const taken = Math.min(next[column], remaining);
        next[column] -= taken;
        remaining -= taken;
      }

      set({ user: next });
    },
  })),
);
